import React from 'react';
import { Link } from 'react-router-dom';
import { Star, Eye } from 'lucide-react';
import { getStreamUrl } from '../api';

const VideoCard = ({ video }) => {
  const thumbnailUrl = getStreamUrl(video.thumbnail_path);

  return (
    <Link
      to={`/video/${video.id}`}
      className="video-card group block rounded-xl overflow-hidden bg-card border border-border/70 dark:border-border hover:shadow-[0_1px_0_rgba(15,23,42,0.08),0_18px_44px_rgba(15,23,42,0.12)]"
      data-testid="video-card"
    >
      <div className="relative aspect-video overflow-hidden bg-muted">
        <img
          src={thumbnailUrl}
          alt={video.title}
          className="video-thumbnail w-full h-full object-cover"
          data-testid="video-card-thumbnail"
        />
        {!video.approved && (
          <div className="absolute top-2 right-2 bg-yellow-500 text-white px-2 py-1 rounded text-xs font-medium">
            En attente
          </div>
        )}
      </div>
      <div className="p-3">
        <h3
          className="text-sm md:text-base font-semibold leading-snug line-clamp-2 mb-1"
          data-testid="video-card-title"
        >
          {video.title}
        </h3>
        <p
          className="text-xs text-muted-foreground mb-2"
          data-testid="video-card-creator"
        >
          {video.creator_username}
        </p>
        <div className="flex items-center gap-3 text-xs text-muted-foreground">
          <span className="flex items-center gap-1" data-testid="video-card-views">
            <Eye className="w-3 h-3" />
            {video.views_count}
          </span>
          {video.stars_avg > 0 && (
            <span className="flex items-center gap-1" data-testid="video-card-rating">
              <Star className="w-3 h-3 fill-yellow-400 text-yellow-400" />
              {video.stars_avg.toFixed(1)}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
};

export { VideoCard };
export default VideoCard;
